/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_UnverifiedInputs */

const th_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่อยู่อีเมลของคุณยังไม่ได้รับการยืนยัน จึงยังปิดการส่งอีเมล`)
};

const en_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your address is not verified yet, so email stays off.`)
};

const ja_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスがまだ確認されていないため、メールはオフのままです。`)
};

const zh_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的邮箱尚未验证，因此邮件仍处于关闭状态。`)
};

const es_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu dirección aún no está verificada, así que el correo sigue desactivado.`)
};

const pt_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu endereço ainda não foi verificado, então o e-mail continua desligado.`)
};

const id_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat Anda belum diverifikasi, jadi email tetap mati.`)
};

const fr_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre adresse n’est pas encore vérifiée, donc l’e-mail reste désactivé.`)
};

const tl_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pa beripikado ang address mo, kaya nananatiling patay ang email.`)
};

const vi_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ của bạn chưa được xác minh, nên email vẫn tắt.`)
};

const ko_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주소가 아직 인증되지 않아 이메일은 꺼진 상태입니다.`)
};

const de_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Adresse ist noch nicht bestätigt, E-Mail bleibt deshalb aus.`)
};

const ru_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш адрес ещё не подтверждён, поэтому почта остаётся выключенной.`)
};

const tr_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresiniz henüz doğrulanmadı, bu yüzden e-posta kapalı kalıyor.`)
};

const it_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo indirizzo non è ancora verificato, quindi l'email resta disattivata.`)
};

const pl_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój adres nie został jeszcze zweryfikowany, więc e-mail pozostaje wyłączony.`)
};

const uk_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вашу адресу ще не підтверджено, тож пошта лишається вимкненою.`)
};

const hi_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका पता अभी सत्यापित नहीं है, इसलिए ईमेल बंद ही रहेगा।`)
};

const ar_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يُوثَّق عنوانك بعد، لذا يبقى البريد موقوفًا.`)
};

const ms_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat anda belum disahkan, jadi e-mel kekal dimatikan.`)
};

const bn_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ঠিকানা এখনও যাচাই হয়নি, তাই ইমেল বন্ধ থাকছে।`)
};

const zh_tw2_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的位址尚未驗證，因此郵件仍為關閉狀態。`)
};

const zh_hk2_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的位址尚未驗證，因此郵件仍為關閉狀態。`)
};

const ur_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کا پتہ ابھی تصدیق شدہ نہیں، اس لیے ای میل بند ہی رہے گی۔`)
};

const fa_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشانی شما هنوز تأیید نشده، پس ایمیل خاموش می‌ماند.`)
};

const sw_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwani yako haijahakikiwa bado, kwa hivyo barua pepe inabaki imezimwa.`)
};

const nl_email_unverified = /** @type {(inputs: Email_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je adres is nog niet bevestigd, dus e-mail blijft uit.`)
};

/**
* | output |
* | --- |
* | "Your address is not verified yet, so email stays off." |
*
* @param {Email_UnverifiedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_unverified = /** @type {((inputs?: Email_UnverifiedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_UnverifiedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_unverified(inputs)
	if (locale === "ja") return ja_email_unverified(inputs)
	if (locale === "zh") return zh_email_unverified(inputs)
	if (locale === "es") return es_email_unverified(inputs)
	if (locale === "pt") return pt_email_unverified(inputs)
	if (locale === "id") return id_email_unverified(inputs)
	if (locale === "fr") return fr_email_unverified(inputs)
	if (locale === "tl") return tl_email_unverified(inputs)
	if (locale === "vi") return vi_email_unverified(inputs)
	if (locale === "ko") return ko_email_unverified(inputs)
	if (locale === "de") return de_email_unverified(inputs)
	if (locale === "ru") return ru_email_unverified(inputs)
	if (locale === "tr") return tr_email_unverified(inputs)
	if (locale === "it") return it_email_unverified(inputs)
	if (locale === "pl") return pl_email_unverified(inputs)
	if (locale === "uk") return uk_email_unverified(inputs)
	if (locale === "hi") return hi_email_unverified(inputs)
	if (locale === "ar") return ar_email_unverified(inputs)
	if (locale === "ms") return ms_email_unverified(inputs)
	if (locale === "bn") return bn_email_unverified(inputs)
	if (locale === "zh-TW") return zh_tw2_email_unverified(inputs)
	if (locale === "zh-HK") return zh_hk2_email_unverified(inputs)
	if (locale === "ur") return ur_email_unverified(inputs)
	if (locale === "fa") return fa_email_unverified(inputs)
	if (locale === "sw") return sw_email_unverified(inputs)
	if (locale === "nl") return nl_email_unverified(inputs)
	return en_email_unverified(inputs)
});